import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
const TOKEN_KEY = "da247-admin-token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/admin") && !err.config.url.includes("/auth/login")) {
      setToken(null);
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

export const fileUrl = (url, cdn) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${(cdn || BACKEND).replace(/\/$/, "")}${url}`;
  return url;
};

const sessionId = () => {
  let s = sessionStorage.getItem("da247-sid");
  if (!s) {
    s = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
    sessionStorage.setItem("da247-sid", s);
  }
  return s;
};

export const heartbeat = () => {
  if (document.visibilityState !== "visible") return;
  try {
    fetch(`${API}/public/heartbeat`, {
      method: "POST", keepalive: true, headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sid: sessionId(), path: window.location.pathname }),
    });
  } catch (_) { /* ignore */ }
};

export const track = (payload) => {
  try {
    fetch(`${API}/public/track`, {
      method: "POST", keepalive: true, headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ referrer: document.referrer || "", ...payload }),
    });
  } catch (_) { /* ignore */ }
};
